import React, { FC, ReactNode } from 'react';

type RootContainerProps = {
	children: ReactNode;
};

export const RootContainer: FC<RootContainerProps> = ({ children }) => (
	<html lang='en'>
		<body>{children}</body>
	</html>
);
